module.exports = __webpack_public_path__ + "img/reclunauta.e074bf69.jpeg";